import axios from 'axios'
import {
  FILE_DOWNLOAD_ALL_FAIL,
  FILE_DOWNLOAD_ALL_REQUEST,
  FILE_DOWNLOAD_ALL_SUCCESS,
  FILE_DOWNLOAD_FAIL,
  FILE_DOWNLOAD_REQUEST,
  FILE_DOWNLOAD_SUCCESS,
} from '../constants/fileConstants'

export const downloadFile = (file) => async (dispatch, getState) => {
  try {
    dispatch({
      type: FILE_DOWNLOAD_REQUEST,
      payload: file.name,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
      responseType: 'blob',
    }

    const { data } = await axios.get(`/api/file/download/${file.id}`, config)

    dispatch({
      type: FILE_DOWNLOAD_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: FILE_DOWNLOAD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const downloadAll = (fileList) => async (dispatch, getState) => {
  try {
    dispatch({
      type: FILE_DOWNLOAD_ALL_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
      responseType: 'blob',
    }

    const { data } = await axios.post(
      `/api/file/download-all`,
      fileList,
      config
    )

    dispatch({
      type: FILE_DOWNLOAD_ALL_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: FILE_DOWNLOAD_ALL_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}
